import type { Visit } from '../api/types';
import { fmt, eL, dur } from '../utils/format';
import { abrirVisita } from '../store/actions/visit.actions';

export function VisitCard({ v }: { v: Visit }) {
  const d = dur(v.fechaCheckin, v.fechaCheckout);
  const sinDueno = !v.tecnicoId;
  return (
    <div
      class="card"
      style={{ cursor: 'pointer', ...(sinDueno ? { borderLeft: '3px solid var(--warning)' } : {}) }}
      onClick={() => abrirVisita(v.id)}
    >
      {v.tipo === 'emergencia' && (
        <span class="badge" style={{ background: '#FCEBEB', color: 'var(--danger)', marginBottom: 4 }}>
          Emergencia
        </span>
      )}
      <div class="row">
        <strong>{v.client?.nombre}</strong>
        <span class={'badge estado-' + v.estado}>{sinDueno ? 'Sin tomar' : eL(v.estado)}</span>
      </div>
      <p class="muted">
        {fmt(v.fechaProgramada)}
        {v.tecnico ? ' · ' + v.tecnico.nombre : ' · Sin técnico'}
        {d !== null ? ' · ' + d + 'min' : ''}
        {v.numeroTicket ? ' · #' + v.numeroTicket : ''}
      </p>
    </div>
  );
}
